import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';
import { SubsidiariesStoreSelectors } from 'apps/console/src/app/root-store/subsidiaries-store';

@Injectable({
	providedIn: 'root'
})
export class HasSubsidiariesGuard implements CanActivate {
	private store = inject(Store);
	private router = inject(Router);

	hasSubsidiaries$ = this.store.select(SubsidiariesStoreSelectors.selectHasSubsidiaries);
	hasLoadedOnce$ = this.store.select(SubsidiariesStoreSelectors.selectHasLoadedOnce);

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		return this.hasLoadedOnce$.pipe(
			filter(hasLoadedOnce => hasLoadedOnce),
			switchMap(_ => this.hasSubsidiaries$),
			map((hasSubsidiaries: boolean) => {
				// Allow this page without subsidiaries only when coming from an invite
				// but the user has been inactivated since.
				if (!hasSubsidiaries && !route.fragment?.includes(RoutesDefinitions.InviteFragment)) {
					this.router.navigate([RoutesDefinitions.getNewAccountCompanyFullPath()]);
					return false;
				}
				return true;
			})
		);
	}
}
